import React from 'react';
import { useParams } from 'react-router-dom';
import { BuilderProvider } from '@/contexts/BuilderContext';
import { PortalBuilderContent } from './PortalBuilderContent';

const PortalBuilderWithContext = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Invalid chatbot ID</div>;
  }

  return (
    <BuilderProvider chatbotId={id}>
      <PortalBuilderContent />
    </BuilderProvider>
  );
};

export default PortalBuilderWithContext;
